module.exports = __webpack_public_path__ + "img/slider2.d2ce88c0.jpg";